import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { currentDateFormat } from "../utils";
//import { PaddingOutlined } from '@mui/icons-material';
import Swal from "../../node_modules/sweetalert2/dist/sweetalert2";
import { Base64 } from "js-base64";
import { BASE_API_URI, SEND_FTP, BULK_UPDATE_BILLING_STATUS } from "../constant";
import { useNavigate } from "react-router-dom";

function BillingProcessSummary() {
  const location = useLocation();
  const navigate = useNavigate();
  const { filePath, jsonData, scheduleIds } = location.state || {};
  const [currentDate, setCurrentDate] = useState(new Date());
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const encodedids = queryParams.get("id");
  const ids = encodedids ? Base64.decode(encodedids) : "";
  console.log("ids::",ids);

  if (!filePath) {
    return (
      <div className="container py-4">
        <div className="alert alert-info">
          No process data available. Please run billing from the prepare step.
          <button
            type="button"
            className="btn btn-primary ms-3"
            onClick={() => navigate("/home/billing/prepare")}
          >
            Go to Billing Prepare
          </button>
        </div>
      </div>
    );
  }

  const relativeFilePath = filePath.split("responses")[1];
  const downloadUrl = `${BASE_API_URI}/responses${relativeFilePath}`;
  //console.log('encodedids',ids);

  const handleDownload = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",
      });

      const text = await response.data.text();

      const jsonResponse = JSON.parse(text);
      const edi837 = jsonResponse[0].EDI837;
      const randomNumber = Math.floor(100000000 + Math.random() * 900000000);
      const now = new Date();
      const dateTime = `${now.getFullYear()}${String(
        now.getMonth() + 1
      ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}${String(
        now.getHours()
      ).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(
        now.getSeconds()
      ).padStart(2, "0")}`;
      // Define the username (replace 'CTcaretapqa' with the actual username if available dynamically)
      const username = userData?.full_name;
      //console.log('username',username);
      // Construct the filename
      //const filename = `A287103500_837P_${randomNumber}_${dateTime}_${username}`;

      const filename = (relativeFilePath || "").split(/[\/\\]/).pop();
      const url = window.URL.createObjectURL(new Blob([edi837]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const sendFTP = async (event) => {
    event.preventDefault();
    if (isSubmitting) return; // Prevent duplicate clicks

    setIsSubmitting(true);
    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",
      });

      const text = await response.data.text();
      const jsonResponse = JSON.parse(text);
      const edi837 = jsonResponse[0].EDI837;

      const randomNumber = Math.floor(100000000 + Math.random() * 900000000);
      const now = new Date();
      const dateTime = `${now.getFullYear()}${String(
        now.getMonth() + 1
      ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}${String(
        now.getHours()
      ).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(
        now.getSeconds()
      ).padStart(2, "0")}`;
      const username = userData?.full_name;
      const filename = (relativeFilePath || "").split(/[\/\\]/).pop();

      const response_1 = await axios.post(SEND_FTP, {
        filename: filename,
        fileContent: edi837,
        schIds: { ids },
      });
      //console.log('response',response_1);
      //alert('File has been sent to FTP successfully');
      if (response_1.data.status === "200") {
        setIsSubmitting(false);
        Swal.fire({
          title: "Success!",
          text: "File has been sent to FTP successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        const response = await axios.patch(
          BULK_UPDATE_BILLING_STATUS,
          {
            scheduleIds: scheduleIds,
            billingStatus: 2,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response?.data?.status === "200") {
          navigate("/home/billing/submittedBatches", { replace: true });
        }
      }
    } catch (error) {
      console.error("Error sending file to FTP:", error);
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleConfirm = async (event) => {
    event.preventDefault();
    if (isConfirming) return; // Prevent duplicate clicks

    if (!scheduleIds || scheduleIds.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "No schedule IDs available to confirm",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setIsConfirming(true);
    try {
      const response = await axios.patch(
        BULK_UPDATE_BILLING_STATUS,
        {
          scheduleIds: scheduleIds,
          billingStatus: 2,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.status === "200") {
        setIsConfirming(false);
        Swal.fire({
          title: "Success!",
          text: "Billing confirmed successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/home/billing/list", { replace: true });
        });
      } else {
        setIsConfirming(false);
        Swal.fire({
          title: "Error!",
          text: response?.data?.message || "Failed to confirm billing status",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error confirming billing status:", error);
      setIsConfirming(false);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <section>
        <div className="d-flex justify-content-between form-container">
          <div>
            <h2 className="fs-5 font-weight-600">Submission Claims </h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section>
        <div className="bg-white  px-5 py-4">
          <div className="line-container">
            <p className="success-message">
              {" "}
              The edi file has been generated successfully.Please click below
              button to download the file.
            </p>
          </div>
          <p className="second-message">
            {" "}
            The edi file has been generated successfully.Please click below
            button to download the file.
          </p>
          {filePath ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
    
                <div style={{ PaddingOutlined: "24px" }}>
                  <button
                    onClick={handleDownload}
                    className="bill-download-btn rounded-1"
                  >
                    DOWNLOAD EDI
                  </button>
                </div>
                <div>
                  <button
                    className="btn rounded-1"
                    onClick={sendFTP}
                    disabled={isSubmitting}
                    style={{
                      backgroundColor: "#2196f3",
                      color: "#fff",
                      height: "43px",
                      width: "13em",
                      border: "none",
                    }}
                  >
                    {isSubmitting ? "Processing..." : "SUBMIT TO FTP"}
                  </button>
                </div>
              </div>
              <div
                style={{
                  marginTop: "2rem",
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  alignItems: "flex-start",
                }}
              >
                <div style={{ fontSize: "16px" }}>
                  <strong>STEP 1:</strong> Upload the downloaded batch file on to{" "}
                  <a
                    href="https://login.zirmed.com/uiss"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#05a530",
                      textDecoration: "underline",
                      fontWeight: "500",
                    }}
                  >
                    WAYSTAR
                  </a>
                </div>
                <div style={{ fontSize: "16px" }}>
                  <strong>STEP 2:</strong> Once uploaded{" "}
                  <button
                    onClick={handleConfirm}
                    disabled={isConfirming}
                    style={{
                      backgroundColor: isConfirming ? "#ccc" : "#ff9800",
                      color: "#fff",
                      border: "none",
                      padding: "6px 16px",
                      borderRadius: "4px",
                      cursor: isConfirming ? "not-allowed" : "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                      opacity: isConfirming ? 0.6 : 1,
                    }}
                  >
                    {isConfirming ? "Confirming..." : "confirm here"}
                  </button>
                </div>
              </div>
              <div style={{ display: "none" }}>
                {jsonData && (
                  <div className="mt-3">
                    <pre
                      style={{
                        backgroundColor: "#f7f7f7",
                        padding: "12px",
                        borderRadius: "6px",
                        maxHeight: "300px",
                        overflow: "auto",
                        margin: 0,
                      }}
                    >
                      {JSON.stringify(jsonData, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            </>
          ) : (
            "No data to display"
          )}
        </div>
      </section>
    </>
  );
}

export default BillingProcessSummary;
